export default "__VITE_ASSET__50VaW1M6__"